// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_CONTACT_BUY_IN_eshop = "Kup na %(eshop)s";
export const BZ_CONTACT_CALL_phone = "Zavolej na %(phone)s";
export const BZ_CONTACT_CALL_phone_OR_BUY_IN_eshop = "Zavolej na %(phone)s nebo kup na %(eshop)s";
export const BZ_CONTACT_OR_BUY_IN_eshop = "nebo kup na %(eshop)s";
export const BZ_CONTACT_OR_CALL_phone = "nebo zavolej na %(phone)s";
export const BZ_CONTACT_OR_CALL_phone_AND_BUY_IN_eshop = "nebo zavolej na %(phone)s a kup na %(eshop)s";
export const BZ_CONTACT_OR_CALL_phone_AND_SEE_IN_eshop = "nebo zavolej na %(phone)s a pozri na %(eshop)s";
export const BZ_CONTACT_OR_SEE_IN_eshop = "nebo pozri na %(eshop)s";
export const BZ_CONTACT_OR_sendmsg = "nebo %(sendmsg)s";
export const BZ_CONTACT_OR_sendmsg_AND_CALL_phone = "nebo %(sendmsg)s a zavolej na %(phone)s";
export const BZ_CONTACT_OR_sendmsg_AND_CALL_phone_AND_SEE_IN_eshop = "nebo %(sendmsg)s, zavolej na %(phone)s a pozri na %(eshop)s";
export const BZ_CONTACT_OR_sendmsg_AND_SEE_IN_eshop = "nebo %(sendmsg)s a pozri na %(eshop)s";
